<script>

import ContractSubmit from './Submit.vue';
import moment from 'moment';
import {axios} from '../../mixins';

moment().format();

export default {

  name: 'ApproveEstimate',

  mixins: [axios],

  components: {ContractSubmit},

  props: {
    approve: {
      required: false,
      type: String,
    },
    reject: {
      required: false,
      type: String,
    },
    user: {
      required: false,
      type: Number,
    },
    complete: {
      required: false,
      type: Boolean,
      default: false,
    },
    sign: {
      required: false,
      type: String,
    },
    home: {
      required: false,
      type: String,
    },
    size: {
      required: false,
      type: Number
    },
    payment: {
      required: false,
      type: String
    },
    orgName: {
      required: true,
      type: String
    },
    offerRetracted: {
      required: false,
      type: Boolean,
      default: false,
    },
    contact: {
      required: false,
      type: Object
    },
    readyToSign: {
      required: false,
      type: Boolean
    }
  },

  data() {
    return {
      message: '',
      status: null,
      approved: null,
      completed: false,
    };
  },

  computed: {},

  created() {
    if (this.complete !== false) {
      this.message = 'Response already submitted.'
      this.completed = true
      this.approved = this.readyToSign
      this.status = 200
    }
  },

  methods: {
    submitApprove() {
      this.post(this.approve, this.identifiers).then((response) => {
        this.message = response.data.message
        this.status = 200
        this.approved = true;
        this.completed = true;
      }).catch((e) => {
        this.message = 'Response was not received.'
      });
    },
    submitReject() {
      this.post(this.reject, this.identifiers).then((response) => {
        this.message = response.data.message
        this.status = 200
        this.approved = false;
        this.completed = true
      }).catch(() => {
        this.message = 'Response was not received.'
      });
    },
  },
};

</script>

<template>

  <div v-if="offerRetracted && (size <= 0) && (payment <= 0)">
    <div class="text-lg font-semibold text-center mb-2">
      Offer Rescinded
    </div>
    We're sorry, but the offer from {{ this.orgName }} has been rescinded. Watch your inbox for a new offer, or reach out to
    {{ this.contact }} for further information or assistance.
  </div>
  <div v-else>
    <div v-if="!completed">
      <div v-if="offerRetracted" class="text-lg font-semibold text-center mb-2">
        New Offer Available
      </div>
      Thank you for your interest in participating in the {{ this.orgName }}! {{ this.offerRetracted
        ? 'Unfortunately, this offer provided via e-mail has been rescinded - after analysis, your new offer is ' :
        'After analyzing your proposed practice changes, we are prepared to offer you '
      }} a payment of <strong>{{ this.payment }}</strong>
      for enrolling <strong>{{ this.size }} acres</strong> in the {{ this.orgName }}.

      <div class="buttons flex flex-row text-center mt-4">
        <!-- Approval Button -->
        <button v-if="approve"
                type="button"
                class="w-1/2 px-6 py-1 rounded-sm text-white font-bold inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mr-2"
                @click="submitApprove">
          <span class="text-md">
            Approve
          </span>
        </button>

        <!-- Reject Button -->
        <button v-if="reject"
                type="button"
                class="w-1/2 px-6 py-1 rounded-sm text-white font-bold inline-block shadow-lg bg-red hover:bg-red-dark focus:bg-red-darker"
                @click="submitReject">
          <span class="text-md">
            Reject
          </span>
        </button>
      </div>

    </div>
    <div v-if="completed">
      <div v-if="status === 200 && approved !== false">
        <p class="text-green my-3 text-center">{{ message }}</p>
        <a :href="this.sign + (this.token ? '/' + this.token : '')">
          <button type="button"
                  class="px-6 py-1 w-full rounded-sm text-white font-bold shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker">
            Proceed to Sign
          </button>
        </a>
      </div>
      <p v-else class="text-red text-center">{{ message }}</p>
    </div>
  </div>
</template>
